module.exports = __webpack_public_path__ + "img/zuijia_47.f5ac5ee4.png";